import Fade from '@material-ui/core/Fade';
import React, { useCallback, useState } from 'react';
import { useCallbackObservable } from 'react-use-observable';
import { useObservable } from 'react-use-observable';
import Actions from 'v2/components/Pages/Help/Actions';
import MyTickets from 'v2/components/Pages/Help/MyTickets';
import NewTicketModal from 'v2/components/Pages/Help/NewTicketModal';
import HyperflowChat from 'v2/components/Shared/Hyperflow';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import helpService from 'v2/services/help';

import HistoryModal from './HistoryModal';

const Help = () => {
  const [isNewModalVisible, setIsNewModalVisible] = useState(false);
  const [isHistoryModalVisible, setIsHistoryModalVisible] = useState(false);
  const [getTicket] = useCallbackObservable((id: number) => helpService.showTicket(id), []);

  const toggleNewTicketModal = () => {
    setIsNewModalVisible((prevState) => !prevState);
  };

  const toggleNewHistoryModal = () => {
    setIsHistoryModalVisible((prevState) => !prevState);
  };

  const handleHistoryClick = useCallback(
    (ticketId: number) => {
      getTicket(ticketId);
      toggleNewHistoryModal();
    },
    [getTicket]
  );

  const [userDetails] = useObservable(() => eduzzAccountsService.getUser(), []);
  const chatOpenedToUnitOnDash = userDetails?.is_elite || userDetails?.has_chat_black || userDetails?.is_clube_black;

  return (
    <Fade in={true} timeout={500}>
      <>
        {!chatOpenedToUnitOnDash && <HyperflowChat />}
        <div className='my-title'>
          <h1>Central de Ajuda</h1>
          <p>Todas suas dúvidas e soluções em um só lugar.</p>
        </div>
        <div className='m24' />
        <Actions />
        <div className='m24' />
        <MyTickets handleNewTicket={toggleNewTicketModal} handleHistoryClick={handleHistoryClick} />
        {isNewModalVisible && <NewTicketModal isOpen={isNewModalVisible} handleClose={toggleNewTicketModal} />}
        {isHistoryModalVisible && <HistoryModal isOpen={isHistoryModalVisible} handleClose={toggleNewHistoryModal} />}
      </>
    </Fade>
  );
};

export default Help;
